import React from 'react'
import "./Loader.scss"

const Loader = () => {
  return (
    <>
      <div class="loader-parent">
        <span class="loader"></span>
      </div>
    </>
  )
}

export default Loader
